import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home, Search } from "lucide-react";
import { Button } from "@/components/ui/Button";

export default function NotFound() {
  const navigate = useNavigate();

  const isAdmin = !!localStorage.getItem("fotomomen_admin_email");
  const isHost = !!localStorage.getItem("fotomomen_userId");

  const handleSmartHome = () => {
    if (isAdmin) {
      navigate("/superadmin");
    } else if (isHost) {
      navigate("/dashboard");
    } else {
      navigate("/");
    }
  };

  const getHomeLabel = () => {
    if (isAdmin) return "Ke Dashboard Admin";
    if (isHost) return "Ke Dashboard Event";
    return "Ke Beranda";
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 flex items-center justify-center mb-6 shadow-inner">
        <Search className="w-8 h-8" />
      </div>

      <span className="text-sm font-semibold tracking-wider text-indigo-400 uppercase mb-2">
        Error 404
      </span>
      <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-3">
        Halaman Tidak Ditemukan
      </h1>
      <p className="text-slate-400 max-w-md mb-8 text-sm sm:text-base">
        Alamat web yang Anda tuju mungkin salah ketik, telah dipindahkan, atau tidak terdaftar di FotoMomen.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
        <Button
          onClick={() => navigate(-1)}
          variant="outline"
          className="w-full flex items-center justify-center gap-2 border-slate-700 text-slate-300 hover:bg-slate-800"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Kembali</span>
        </Button>
        <Button
          onClick={handleSmartHome}
          className="w-full flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold"
        >
          <Home className="w-4 h-4" />
          <span>{getHomeLabel()}</span>
        </Button>
      </div>
    </div>
  );
}
